/**
 * Optional configuration. There are no secrets and no credentials here: the app
 * talks to no server. Every value has a working default so a missing .env is
 * never an error.
 */

type Env = Record<string, string | boolean | undefined>;

const env: Env = (import.meta as unknown as { env?: Env }).env ?? {};

function str(key: string, fallback: string): string {
  const value = env[key];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

function bool(key: string, fallback: boolean): boolean {
  const value = env[key];
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return fallback;
  return value !== 'false' && value !== '0';
}

function int(key: string, fallback: number): number {
  const value = env[key];
  if (typeof value !== 'string') return fallback;
  const n = Number.parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

/**
 * Set at build or dev-server start. Shown in the status bar so it is obvious
 * when a tab is running code older than the server.
 */
declare const __BUILD_STAMP__: string | undefined;
export const BUILD_STAMP: string =
  typeof __BUILD_STAMP__ === 'string' ? __BUILD_STAMP__ : new Date(0).toISOString();

export const CONFIG = {
  appTitle: str('VITE_APP_TITLE', 'Slate Whiteboard'),
  seedSamples: bool('VITE_SEED_SAMPLES', true),
  syncChannel: str('VITE_SYNC_CHANNEL', 'slate-whiteboard-sync'),
  maxImportBytes: int('VITE_MAX_IMPORT_BYTES', 8 * 1024 * 1024),
} as const;
